<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>

    <selectTool ref="selectTool">
      <template slot="text">角色列表</template>
      <template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
      <template slot-scope="{ row, index }" slot="icon">
        <img :src="'static/' + row.icon + '/4/3.gif'" style="width: 30px" />
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="shouquan(row, 1)" :disabled="row.keep"
          >PC授权</Button
        >
        <Button size="small" @click="shouquan(row, 2)" :disabled="row.keep"
          >移动授权</Button
        >
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row)" :disabled="row.keep"
          >删除</Button
        >
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <Drawer
      :title="modalTitle"
      placement="right"
      :closable="true"
      v-model="openRole"
      draggable
    >
      <authority
        v-if="openRole"
        :roleId="id"
        :platformId="platformId"
        :scope="scope"
        @openRole="openRole = false"
      ></authority>
    </Drawer>

    <form-model
      :title="isAdd ? '新增角色' : '编辑角色'"
      width="700"
      ref="formModel"
    >
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
import authority from "./authority";

export default {
  components: { authority },
  data() {
    return {
      modalTitle: "",
      openRole: false,
      platformId: "",
      isAdd: false,
      columns: [],
      tableData: [],
      item: {
        data: "1", //数据（1-所有，2-所在部门及以下，3-所在部门，4-本人）,可用值:1,2,3,4
        groupId: "",
        name: "",
        remark: "",
        groupName: "",
        type: "1",
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
      categorys: [],
      forms: [
        {
          title: "角色名称",
          key: "name",
          multiple: true,
          type: "Input",
          required: true,
        },
        {
          title: "单位名称",
          key: "groupId",
          key1: "groupName",
          type: "selectGroup",
          required: true,
        },
        {
          title: "角色类型",
          key: "type",
          key2: "type2",
          type: "Select1",
          st: "roleType",
          required: true,
        },
        {
          title: "权限范围",
          key: "data",
          key2: "data2",
          type: "Select1",
          st: "roleData",
          required: true,
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          type1: "textarea",
          required: true,
        },
      ],
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
          sort: 0,
        },
        {
          title: "创建者账号",
          key: "createAccount",
          sort: 20,
        },
        {
          title: "创建时间",
          key: "createTime",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.createTime, "yymmdd"));
          },
          sort: 20,
        },
        {
          title: "操作",
          slot: "action",
          width: 240,
          align: "center",
          fixed: "right",
          sort: 20,
        },
      ],
      searchForms: [],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.bm + "/role/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].data = String(data[i].data);
          data[i].data2 = this.$t("roleData." + data[i].data);
          data[i].type = String(data[i].type);
          data[i].type2 = this.$t("roleType." + data[i].type);
        }
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.bm + "/role/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.bm + "/role/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.bm + "/role/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    shouquan(row, t) {
      // this.openRoleForm = true;
      this.modalTitle = "授权给（" + row.name + "）";
      this.id = row.id;
      this.platformId = this.axios.keyObj.platformId;
      this.openRole = true;
      this.scope = t;
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    this.columns = this.utils.cols(this.forms, this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/system/role.vue